// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"c12f5be3","64":"d945b2f5","150":"bce818c9","453":"0cd24f2b","508":"02cab3a9","941":"ae4df86f"}[chunkId] + ".chunk.js";
};